import { render, staticRenderFns } from "./Sla.vue?vue&type=template&id=622a8f17"
import script from "./Sla.vue?vue&type=script&lang=js"
export * from "./Sla.vue?vue&type=script&lang=js"
import style0 from "./Sla.vue?vue&type=style&index=0&id=622a8f17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports